import owd from 'owd/owd';
import Modal from './modal';
import 'lib/js-cookie';

export default class Newsletter extends Modal {
	init() {
        this.cookiesName = 'newsletter-womad';

        super.init();
		this.bind();
    }
    
    setCookie() {
        Cookies.set(this.cookiesName, "yes", {
            expires: 365,
            path: '/'
        });
    }

	bind() {
        super.bind();

        this.on('load ajaxload', this.dom.$window, () => {
            if(Cookies.get(this.cookiesName) === undefined) {
                this.$element.trigger('show');
            }
        });

        this.on('click', this.closeButton, () => {
            this.setCookie();
        });

        // this.on('load ajaxload resize', this.dom.$window, () => {
        //     if (window.innerWidth < 1200) {
        //         this.on('click', this.dom.$body, () => {
        //             this.$element.addClass('is-hidden');
        //             this.setCookie();
        //         });
        //         this.on('scroll', this.dom.$window, () => {
        //             this.$element.addClass('is-hidden');
        //             this.setCookie();
        //         });
        //     }
        // })
    }
}

owd.registerComponent('newsletter', {
	component: Newsletter
});
